<template>

    <div class="form-container" v-if="mode == 'form'">
        <form novalidate>
            <form-page
                @submitted="onSubmitted"
                ref="form"
                v-if="ready"></form-page>
        </form>
    </div>

    <div ref="submitMessage" class="form-container submitted-message" v-if="mode == 'submitted' && message != ''">
        <div v-html="message"></div>
    </div>

</template>


<script>
export default {
    name       : 'Formulaire',
    components : [],
}
</script>


<script setup>
import {computed, ref, onMounted, inject, shallowRef, nextTick} from "vue";
import { useStore }                                             from "vuex";
import FormPage                                         from "./vue/FormPage.vue";

//init
let store                  = useStore();
const injectedCopydeck     = inject( 'copydeck' );
const injectedForm = inject( 'form' );

//COMPUTED
let ready = computed( () => store.state.ready );
let mode = ref( "form");
let message = ref("");
let actions = computed( () => store.state.actions);
let form = ref(null)
let submitMessage = ref(null);

function hydrateField (field,value)
{
    form.value.hydrateField(field, value);
}

function onSubmitted ()
{
    mode.value = 'submitted';

    for (let i = 0; i < actions.value.length; i++)
    {
        let action = actions.value[i];

        let type = action.type;

        if (type === "display_message")
        {
            message.value = action.message;

            nextTick(() =>
            {
                if (submitMessage.value)
                {
                    submitMessage.value.scrollIntoView({behavior: "smooth"});
                }
            })


        }
    }

}

async function mounted ()
{

    store.commit( 'copydeck', injectedCopydeck );
    await store.dispatch( 'form', injectedForm );


    store.commit( "ready" );

    let event = new CustomEvent("form-ready", { detail: {form_id: injectedForm, hydrateField}})

    setTimeout(() => window.dispatchEvent(event), 1);

}



onMounted( mounted );
defineExpose( { hydrateField })

</script>


